<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { slide } from 'svelte/transition';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import Row from '$components/Form/Row.svelte';
    import * as NewsfeedFiltersData from '$components/SearchHeader/NewsfeedFilters/NewsfeedFiltersData';
    import StackZIndex from '$components/ZIndex/StackZIndex.svelte';
    import Select from '$components/Form/Select.svelte';
    import * as t from '$trans';
    import FormWrapper from './FormWrapper.svelte';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let form: Form<TValues, string>;
    export let newsfeedFiltersFields: NewsfeedFiltersData.Fields<TValues>;
    export let showFiltersField: Field<TValues, boolean>;
</script>

<FormWrapper
    {form}
    {newsfeedFiltersFields}
    {showFiltersField}
    let:showFilters
    let:categoryOptions
    let:subCategoryOptions
    let:typeOptions
    let:selectedCategory
    let:selectedSubCategory
    let:valueToOption
    let:hideFilters
    let:resetFilters
>
    <StackZIndex zIndex="current" let:zIndex>
        <div class="container mx-auto mt-[-50px]">
            {#if showFilters}
                <div
                    transition:slide
                    class={`z-[--z-index] w-full relative bg-gray-350 rounded-b-[32px]`}
                    style={`--z-index: ${zIndex - 1};`}
                >
                    <div class="px-[32px] pb-[24px] pt-[50px] flex flex-col gap-[24px]">
                        <div class="flex flex-col gap-[16px]">
                            <div class="grid grid-cols-3 gap-[32px]">
                                <Row
                                    {form}
                                    field={newsfeedFiltersFields.category}
                                    let:field
                                    label="Catégorie de la publication"
                                >
                                    <Select
                                        class="svelte-select-sm svelte-select-bg-white"
                                        {form}
                                        {field}
                                        required={false}
                                        clearable
                                        showChevron
                                        searchable={false}
                                        placeholder=""
                                        options={categoryOptions}
                                    />
                                </Row>
                                {#if selectedCategory != null && subCategoryOptions.length > 0}
                                    <Row
                                        {form}
                                        field={newsfeedFiltersFields.subCategory}
                                        let:field
                                        label="Sous-catégorie de la publication"
                                    >
                                        <Select
                                            class="svelte-select-sm svelte-select-bg-white"
                                            {form}
                                            {field}
                                            required={false}
                                            clearable
                                            showChevron
                                            searchable={false}
                                            placeholder=""
                                            options={subCategoryOptions}
                                        />
                                    </Row>
                                {/if}

                                {#if selectedSubCategory != null && typeOptions.length > 0}
                                    <Row
                                        {form}
                                        field={newsfeedFiltersFields.types}
                                        let:field
                                        label="Type d’annonce"
                                    >
                                        <MeltMultiSelect
                                            {form}
                                            {field}
                                            placeholder=""
                                            options={typeOptions}
                                            {valueToOption}
                                        />
                                    </Row>
                                {/if}
                            </div>
                        </div>

                        <div class="flex">
                            <button
                                type="button"
                                class="btn-reset flex gap-4 items-center justify-center hover:cursor-pointer hover:opacity-80 text-gray-800 text-14 font-bold"
                                on:click|preventDefault={resetFilters}
                            >
                                <i class="tnp tnp-refresh text-12" aria-hidden={true} />
                                Effacer les filtres
                            </button>
                            <div class="flex-1"></div>
                            <button
                                type="button"
                                class="btn-reset flex gap-4 items-center justify-center hover:cursor-pointer hover:opacity-80 text-gray-800 text-14 font-bold"
                                on:click|preventDefault={hideFilters}
                            >
                                <i class="fa fa-chevron-up text-12" aria-hidden={true} />
                                <span>{t.ui.close({}, $lang)}</span>
                            </button>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </StackZIndex>

    <div class="h-[50px]"></div>
</FormWrapper>
